import { render } from "./ThongTinDangThucHien.vue?vue&type=template&id=66acf88e"
import script from "./ThongTinDangThucHien.vue?vue&type=script&lang=js"
export * from "./ThongTinDangThucHien.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__